import BaseService from './base';

export interface DynastyViewModel {
  id?: number;
  name?: string;
  introduce?: string;
  startYear?: number;
  endYear?: number;
  displayPos?: number;
}

export  class DynastyService extends BaseService<DynastyViewModel> {
  protected serviceApi: string = 'Dynasty';

  get NewModel(): DynastyViewModel {
    return {
      id: 0,
      name: '',
    };
  }
}
